<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="show = !show; if (show) { getClasses(); }"
        >Add/Remove User to Class</button>
        <br />
        <div v-if="show">
            <br />
            <v-select :items="opt" v-model="action" label="Select Action"></v-select>
            <v-select v-if="action" :items="classes" label="Select Class" v-model="selectedClass"></v-select>
            <div v-if="selectedClass">
                <div style="display:flex">
                    <v-text-field
                        v-model.trim="email"
                        :error-messages="emailErr"
                        label="Enter student email"
                        @keydown.enter="checkComplete ? add() : null"
                    ></v-text-field>
                    <v-icon :disabled="!checkComplete" @click="add()">mdi-plus</v-icon>
                </div>
                <div>
                    Selected users:
                    <span
                        v-for="(user, i) in users"
                        :key="user"
                        @click="users.splice(users.indexOf(student), 1)"
                        style="cursor:pointer"
                    >{{ i==users.length-1 ? `${user}` : `${user}, ` }}</span>
                </div>
                <div v-if="action == 'Remove'"><b>Only remove users if you are absolutely certain of the consequences</b></div>
                
                <button
                    class="btn btn-sm btn-outline-success mt-3"
                    :disabled="!users.length"
                    @click="act()"
                >Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
import { mapState } from "vuex";
import { debounce } from "lodash";

const addUsers = fb.functions.httpsCallable("addUsers");
const removeUsers = fb.functions.httpsCallable("removeUsers");

export default {
    data() {
        return {
            show: false,
            opt: ["Add", "Remove"],
            action: "",
            classes: [],
            selectedClass: null,
            checkComplete: false,
            email: "",
            emailErr: "",
            users: [],
        };
    },
    watch: {
        email: function (newVal, oldVal) {
            this.checkComplete = false;
            this.emailErr = "";
            if (!newVal) {
                return;
            }
            this.debouncedChange();
        },
        selectedClass: function (newVal, oldVal) {
            this.email = "";
            this.users = [];
        },
        action: function (newVal, oldVal) {
            this.selectedClass = null;
        },
    },
    created() {
        this.debouncedChange = debounce(this.change, 1000);
    },
    computed: {
        ...mapState(["admin", "userProfile"]),
    },
    methods: {
        getClasses() {
            if (this.classes.length) {
                return;
            }
            if (this.admin) {
                fb.db
                    .collection("classes")
                    .where("active", "==", true)
                    .get()
                    .then((qs) => {
                        qs.forEach((doc) => {
                            if (this.show) {
                                this.classes.push(doc.data().name);
                            }
                        });
                    });
            } else {
                this.classes = this.userProfile.classes;
            }
        },
        change() {
            if (!this.email) {
                return;
            }
            const query = fb.db
                .collection("users")
                .where("email", "==", this.email.toLowerCase());

            query.get().then((qs) => {
                if (qs.empty) {
                    this.emailErr = "No user found";
                } else {
                    fb.db
                        .collection("classes")
                        .where("name", "==", this.selectedClass)
                        .where(
                            "users",
                            "array-contains",
                            this.email.toLowerCase()
                        )
                        .get()
                        .then((qs) => {
                            if (this.action == "Add") {
                                if (qs.empty) {
                                    this.checkComplete = true;
                                } else {
                                    this.emailErr = `User already in class`;
                                }
                            } else {
                                if (qs.empty) {
                                    this.emailErr = `User not in class`;
                                } else {
                                    this.checkComplete = true;
                                }
                            }
                        });
                }
            });
        },
        add() {
            this.users.includes(this.email.toLowerCase())
                ? null
                : this.users.push(this.email.toLowerCase());
            this.email = "";
        },
        act() {
            if (this.action == "Add") {
                addUsers({
                    class: this.selectedClass,
                    users: this.users,
                }).then((res) => {
                    console.log(res.data);
                    this.$emit(
                        "toast",
                        "war",
                        "Process complete. Check logs in developer console."
                    );
                });
            } else {
                removeUsers({
                    class: this.selectedClass,
                    users: this.users,
                }).then((res) => {
                    console.log(res.data);
                    this.$emit(
                        "toast",
                        "war",
                        "Process complete. Check logs in developer console."
                    );
                });
            }
            this.action = null;
            this.show = false;
        },
    },
};
</script>